import React from 'react';
import { T, NUMERIC, money } from '../customer/customers.theme';
import { EditIcon, TrashIcon } from '../customer/CustomersUI';
import { Thumbnail } from './MenuUI';
import { initialsOf } from './menuApi';

/**
 * One dish on the menu board.
 *
 * Picture, name, price, and the two things you can do to it. The actions are
 * always drawn rather than revealed on hover: a control you have to hunt for is
 * one people stop believing exists, and this screen is worked with a mouse in
 * one hand and a ticket in the other.
 */

function CardAction({ label, tone, onClick, children }) {
  const [hovered, setHovered] = React.useState(false);
  const danger = tone === 'danger';

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        background: hovered ? (danger ? T.dangerTint : T.hover) : 'transparent',
        border: 'none',
        borderRadius: T.radiusControl,
        color: hovered ? (danger ? T.danger : T.ink) : T.inkGhost,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default function MenuItemCard({ item, categoryName, currency, canEdit, onEdit, onDelete }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: T.surface,
        border: `1px solid ${T.border}`,
        borderRadius: T.radiusPanel,
        overflow: 'hidden',
      }}
    >
      <Thumbnail src={item.imageUrl} initials={initialsOf(item.name)} height={118} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '11px 12px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
          <span
            title={item.name}
            style={{
              flex: 1,
              minWidth: 0,
              fontSize: 13.5,
              fontWeight: 600,
              color: T.ink,
              lineHeight: 1.35,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {item.name}
          </span>

          {canEdit ? (
            <span style={{ display: 'flex', gap: 2, marginTop: -3, marginRight: -5 }}>
              <CardAction label="Edit" onClick={() => onEdit(item)}>
                <EditIcon size={14} />
              </CardAction>
              <CardAction label="Delete" tone="danger" onClick={() => onDelete(item)}>
                <TrashIcon size={14} />
              </CardAction>
            </span>
          ) : null}
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <span style={{ fontSize: 15, fontWeight: 700, color: T.brand, ...NUMERIC }}>
            {money(item.price, currency)}
          </span>
          <span
            style={{
              fontSize: 11.5,
              color: T.inkFaint,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {categoryName}
          </span>
        </div>
      </div>
    </div>
  );
}
